import { render, staticRenderFns } from "./create-edit.vue?vue&type=template&id=4e45a42d"
import script from "./create-edit.vue?vue&type=script&lang=js"
export * from "./create-edit.vue?vue&type=script&lang=js"
import style0 from "./create-edit.vue?vue&type=style&index=0&id=4e45a42d&prod&lang=css"
import style1 from "./create-edit.vue?vue&type=style&index=1&id=4e45a42d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports